import {useSnackbar} from "@dain/mui-components";
import {useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useState} from "react";
import {CommonTranslKey} from "../../../common/CommonTranslKey";
import {useClientLocator} from "../../../client/ApiClientLocator";
import {IdentitySource, UserDto} from "../../../client/user/User";
import {FormSessionOpenerInternalUserPage} from "./FormSessionOpenerInternalUserPage";
import {FormSessionOpenerNiaUserPage} from "./FormSessionOpenerNiaUserPage";
import {useLocation} from "react-router-dom";
import InformationDialog from "../../../common/dialog/InformationDialog";
import {FormSessionTranslKey} from "../FormSessionTranslKey";

export function FormSessionOpenerPage() {
    const {t} = useTranslation();
    const {userClient} = useClientLocator();
    const snackbar = useSnackbar();
    const [userIdentitySource, setUserIdetitySource] = useState<IdentitySource>();
    const [canOpenFormSession, setCanOpenFormSession] = useState<boolean>();

    const search = useLocation().search;
    const searchParams = new URLSearchParams(search);
    const documentType = searchParams.get('type');
    const documentVersion = searchParams.get('version');
    const openerParams: Record<string, string> = {};
    searchParams.forEach((value, key) => {
        if (key !== 'type' && key !== 'version') {
            openerParams[key] = value;
        }
    });

    const resolveUserIdentitySource = useCallback((user?: UserDto): void => {
        if (user) {
            setCanOpenFormSession(user.acl.canOpenFormSession)
            setUserIdetitySource(user.identitySource);
        } else {
            setUserIdetitySource(undefined);
        }
    }, []);

    const fetchAndSetUserIdentitySource = useCallback((): void => {
        userClient.findMe()
            .then(resolveUserIdentitySource)
            .catch((error) =>
                snackbar.error(t(CommonTranslKey.UNEXPECTED_ERROR), error)
            );
    }, [userClient, resolveUserIdentitySource, snackbar, t]);

    useEffect(() => {
        fetchAndSetUserIdentitySource();

    }, [fetchAndSetUserIdentitySource, userIdentitySource]);

    return (
        <>
            {userIdentitySource === IdentitySource.INTERNAL &&
                <FormSessionOpenerInternalUserPage documentType={documentType}
                                                   documentVersion={documentVersion}
                                                   openerParams={openerParams} />
            }

            {userIdentitySource === IdentitySource.NIA && canOpenFormSession &&
                <FormSessionOpenerNiaUserPage documentType={documentType}
                                              documentVersion={documentVersion}
                                              openerParams={openerParams} />
            }

            {userIdentitySource === IdentitySource.NIA && !canOpenFormSession &&
                <InformationDialog
                    open={true}
                    onClose={() => window.close()}
                    title={t(FormSessionTranslKey.FORM_SESSION_LOAD_FAILED_TITLE)}
                    primaryButton={{
                        onClick: () => window.close(),
                        title: t(CommonTranslKey.CLOSE)
                    }}
                >
                    {t(FormSessionTranslKey.FORM_SESSION_LOAD_FAILED_MISSING_DATA)}
                </InformationDialog>
            }
        </>
    );
}
